import styled from 'styled-components';
import {
  screenSize,
  primaryColor,
  whiteColor,
  regularFont,
  secondaryColor,
  appBackgroundColor,
} from '@app/styles';

type Props = {
  disabled?: boolean;
  enabled?: boolean;
};
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 65px;
`;
export const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.desktop}) {
    display: flex;
    align-items: center;
    width: 680px;
    height: 520px;
    background: ${whiteColor};
    box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
    flex-direction: column;
    border-radius: 8px;
    padding: 0;
  }
`;
export const EmailIcon = styled.div`
  text-align: center;
  margin-top: 20px;
`;
export const SuccessText = styled.p`
  font-size: 24px;
  color: #0059b8;
  letter-spacing: -0.4px;
  text-align: center;
  margin-top: -5px;
  opacity: 0.8;
  @media (${screenSize.tablet}) {
    font-size: 24px;
    ${regularFont};
  }
`;
export const Text = styled.p`
  font-size: 16px;
  color: #353f5e;
  text-align: center;
  line-height: 30px;
  opacity: 0.8;
  margin-top: -5px;
  @media (${screenSize.tablet}) {
    font-size: 18px;
  }
`;
export const OtpText = styled.p`
  font-size: 14px;
  color: #353f5e;
  text-align: center;
  line-height: 30px;
  margin-top: 0px;
  @media (${screenSize.tablet}) {
    font-size: 16px;
  }
`;
export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
`;
export const RowItem = styled.div`
  margin-right: 20px;
`;
export const ButtonContainer = styled.div`
  width: 100%;
  button{
            color:${primaryColor};
            background-color:${appBackgroundColor};
          }
  color:${primaryColor};
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
     
          button{
            pointer-events:none;
            color:rgba(36,41,50,0.5);
             background-color:${appBackgroundColor};
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
  }
`;
export const ResendButton = styled.div`
 width: 100%;
  margin-right: 15px;
  button{
            color:${secondaryColor};
            background-color:${appBackgroundColor};
          }
  ${({ enabled }: Props) => {
    if (enabled) {
      return `
          button{
            color:rgba(36,41,50,0.5);
            pointer-events:none;
             background-color:${appBackgroundColor};
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Footer = styled.div`
  border-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 30px;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;
export const SavingIndicator = styled.div`
  margin-right: 50px;
  top: 15px;
  svg {
    path {
      fill: ${primaryColor};
    }
  }
  @media (${screenSize.tablet}) {
    left: 30px;
    margin-right: 50px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;
export const ErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  text-align: center;
  @media (${screenSize.tablet}) {
    text-align: center;
  }
`;
